<template>
  <div>
    <v-snackbar class="pa-0" style="z-index:1000 !important;top:7%" light timeout="1000" v-model="alertShow" width="fit-content" top centered>
      <v-alert
        v-model="alertShow"
        dismissible
        :icon="alertSuccess ? 'mdi-check-circle-outline' : 'mdi-cancel'"
        class="mb-0 pa-1"
        :class="alertSuccess ? 'profile-alert-success' : 'profile-alert-failed'"
        light
        close-icon="mdi-close"
      >
        {{ alertMessage }}
      </v-alert>
    </v-snackbar>
    <div class="game-banner">
      <!-- <v-carousel class="banner" cycle delimiter-icon="panorama_fish_eye" :show-arrows="false" interval="10000" height="auto">
          <v-carousel-item v-for="(banner, i) in bannerContent" :key="i">
              <v-img :src="`${banner.desktop_banner}`" @click="callBannerAction(banner.action)" :contain="true" :aspect-ratio="3"></v-img>
          </v-carousel-item>
      </v-carousel> -->
      <v-img v-if="!$vuetify.breakpoint.xsOnly" class="align-center" :src="`/static/image/game/banner/vipTier_banner.jpg`">
        <div class="fill-height">
          <v-row no-gutters align="center" justify="start" class="fill-height" style="max-width: 1240px; margin: auto;">
            <v-col cols="6">
              <label class="ml-3 vip-tier-header-font-size-bigger yellow-theme-color" style="text-transform: capitalize">{{ $t(`label.vipTier_description_a`) }}</label>
              <p class="ml-3 mb-1 mt-1 white--text subtitle-1">
                {{ $t(`label.vipTier_description_b`) }}
              </p>
              <p class="ml-3 mb-0 white--text subtitle-2">
                {{ $t(`label.vipTier_description_c`) }}
              </p>
              <p class="ml-3 mb-0 white--text subtitle-2">
                {{ $t(`label.vipTier_description_d`) }}
              </p>
              <p class="ml-3 mt-2 white--text subtitle-2">
                {{ $t(`label.vipTier_description_e`) }}
              </p>
              <p class="yellow-theme-color vipTier-description-text subtitle-1 col-5">
                {{ $t(`label.vipTier_description_f`) }}
              </p>
            </v-col>
          </v-row>
        </div>
      </v-img>
      <v-img v-if="false" class="align-end" :aspect-ratio="774 / 326" :src="`/static/image/game/banner/banner_m.jpg`"></v-img>
    </div>
    <div v-if="$vuetify.breakpoint.xsOnly" style="background-color: #000;">
      <div class="vip-tier">
        <h1 class="viptitle px-3 py-5">{{ $t(`label.bhai88`) }} {{ $t(`label.viptier`) }}</h1>
        <v-row no-gutters class="MB-row" style="height: 230px;margin-top: 5%;">
          <!--   first draft design   -->
          <!--      <v-col cols="6" class="nav-container">-->
          <!--        <div class="mx-auto nav-wrapper">-->
          <!--          <v-card class="nav-item" :to="{ name: routeName.VIP }">-->
          <!--            <img loading="lazy" class="img-nav-item" :src="`/static/svg/mobileMemberBalance/bettingPass.svg`" />-->
          <!--          </v-card>-->
          <!--          <span class="nav-item-span">{{ $t(`mobileMenuTitle.bettingPass`) }}</span>-->
          <!--        </div>-->
          <!--        <div class="mx-auto nav-wrapper">-->
          <!--          <v-card class="nav-item" :to="{ name: routeName.REWARDS }">-->
          <!--            <img loading="lazy" class="img-nav-item" :src="`/static/svg/mobileMemberBalance/rewards.svg`" />-->
          <!--          </v-card>-->
          <!--          <span class="nav-item-span">{{ $t(`mobileMenuTitle.rewards`) }}</span>-->
          <!--        </div>-->
          <!--        <div class="mx-auto nav-wrapper">-->
          <!--          <v-card class="nav-item" :to="{ name: routeName.TRANSACTION_HISTORY }">-->
          <!--            <img loading="lazy" class="img-nav-item" :src="`/static/svg/mobileMemberBalance/betHistory.svg`" />-->
          <!--          </v-card>-->
          <!--          <span class="nav-item-span">{{ $t(`mobileMenuTitle.betHistory`) }}</span>-->
          <!--        </div>-->
          <!--        <div class="mx-auto nav-wrapper">-->
          <!--          <v-card class="nav-item" :to="{ name: routeName.WITHDRAWAL }">-->
          <!--            <img loading="lazy" class="img-nav-item" :src="`/static/svg/mobileMemberBalance/withdrawal.svg`" />-->
          <!--          </v-card>-->
          <!--          <span class="nav-item-span">{{ $t(`mobileMenuTitle.withdrawal`) }}</span>-->
          <!--        </div>-->
          <!--      </v-col>-->
          <!--  2nd draft design    -->
          <!--          <v-col cols="12" class="MB-right-col d-flex align-center">-->
          <!--            <v-row class="justify-center align-center" no-gutters>-->
          <!--              &lt;!&ndash;              <v-btn @click="showPreviousLevel" class="btnleft">&ndash;&gt;-->
          <!--              &lt;!&ndash;                <img loading="lazy" src="/static/svg/wheel/RightBtn.png" style="transform: scaleX(-1); background-color: transparent;" width="10" height="15" />&ndash;&gt;-->
          <!--              &lt;!&ndash;              </v-btn>&ndash;&gt;-->
          <!--              &lt;!&ndash;              <v-avatar v-if="previousTextColor" @click="showPreviousLevel" class="tierSidePng faded-rank">&ndash;&gt;-->
          <!--              &lt;!&ndash;                <v-img :src="`/static/svg/vipassets/VIP_${previousTextColor().toLowerCase()}_Wing.png`" height="auto" eager></v-img>&ndash;&gt;-->
          <!--              &lt;!&ndash;              </v-avatar>&ndash;&gt;-->
          <!--              <div class="rank-container">-->
          <!--                <div class="half-container left-half">-->
          <!--                  <v-avatar v-if="previousTextColor" class="tierpng faded-rank">-->
          <!--                    <v-img :src="`/static/svg/vipassets/VIP_${previousTextColor().toLowerCase()}_Wing.png`" class="half-image left-image" height="auto" eager></v-img>-->
          <!--                  </v-avatar>-->
          <!--                </div>-->
          <!--                <v-avatar tile class="tierpng">-->
          <!--                  &lt;!&ndash;            <v-img v-if="memberVipTierProgress && memberVipTierProgress.image" :src="`${memberVipTierProgress.image}`"></v-img>&ndash;&gt;-->
          <!--                  &lt;!&ndash;            <v-img v-else :src="`/static/svg/vipassets/vip_${tierColorThemeName}.svg`" eager></v-img>&ndash;&gt;-->
          <!--                  <v-img :src="`/static/svg/vipassets/VIP_${getTextColor().toLowerCase()}_Wing.png`" height="auto" eager></v-img>-->
          <!--                </v-avatar>-->
          <!--                <v-avatar v-if="nextTextColor" @click="showNextLevel" class="tierSidePng faded-rank">-->
          <!--                  <v-img :src="`/static/svg/vipassets/VIP_${nextTextColor().toLowerCase()}_Wing.png`" height="auto" eager></v-img>-->
          <!--                </v-avatar>-->
          <!--                &lt;!&ndash;              <v-btn @click="showNextLevel" class="btnright ">&ndash;&gt;-->
          <!--                &lt;!&ndash;                <img loading="lazy" src="/static/svg/wheel/RightBtn.png" style="background-color: transparent" width="10" height="15" />&ndash;&gt;-->
          <!--                &lt;!&ndash;              </v-btn>&ndash;&gt;-->
          <!--              </div>-->
          <!--            </v-row>-->
          <!--          </v-col>-->
          <div class="rank-container" @touchstart="handleTouchStart" @touchend="handleTouchEnd">
            <!-- Left (Previous Rank - Show Only Right Half) -->
            <div class="half-container right-half ">
              <v-avatar @click="showPreviousLevel" v-if="previousTextColor" class="tierSidePng faded-rank">
                <v-img v-if="this.level != 1" :src="`/static/svg/vipassets/VIP_${previousTextColor().toLowerCase()}_Wing.png`" class="half-image left-image" height="auto" eager></v-img>
              </v-avatar>
            </div>
            <v-btn @click="showPreviousLevel" class="btnleft">
              <img loading="lazy" v-if="this.level != 1" src="/static/svg/wheel/RightBtn.png" style="transform: scaleX(-1); background-color: transparent;" width="10" height="15" />
            </v-btn>
            <!-- Center (Current Rank - Full Visibility) -->
            <v-avatar tile class="tierpng">
              <v-img :src="`/static/svg/vipassets/VIP_${getTextColor().toLowerCase()}_Wing.png`" height="auto" eager></v-img>
            </v-avatar>
            <v-btn @click="showNextLevel" class="btnright ">
              <img loading="lazy" v-if="this.level != this.levelNames.length" src="/static/svg/wheel/RightBtn.png" style="background-color: transparent" width="10" height="15" />
            </v-btn>
            <!-- Right (Next Rank - Show Only Left Half) -->
            <div class="half-container left-half">
              <v-avatar @click="showNextLevel" v-if="nextTextColor" class="tierSidePng faded-rank">
                <v-img
                  v-if="this.level != this.levelNames.length"
                  :src="`/static/svg/vipassets/VIP_${nextTextColor().toLowerCase()}_Wing.png`"
                  class="half-image right-image"
                  height="auto"
                  eager
                ></v-img>
              </v-avatar>
            </div>
          </div>
        </v-row>
        <!--        <p class="title2">{{ $t(`label.currentstatus`) }}</p>-->
        <v-row no-gutters>
          <v-row no-gutters style="height: 70px; align-items: center">
            <v-progress-linear class="customviptierprogress d-flex align-center" width="95%" height="10" color="#FF5AE4" :value="currentProgress" rounded>
              <template v-slot:progress>
                <div v-for="(progress, index) in progressLevels" :key="index" :class="['v-progress-linear__progress__segment', 'tier-' + progress.toLowerCase()]">
                  {{ progress }}
                </div>
              </template>
            </v-progress-linear>
            <v-col cols="12" class="d-flex pa-0 justify-space-around" style="position: absolute; width: 100%;">
              <div class="pa-0 align-center d-flex justify-center" v-for="tier in tiers" :key="tier.name">
                <v-avatar @click="selectVipTierLevel(tier.id)" tile class="tier-all-png">
                  <v-img :src="`/static/svg/vipassets/vip_${tier.color}.png`" style="order: 2;"></v-img>
                </v-avatar>
              </div>
            </v-col>
          </v-row>
        </v-row>
        <v-row no-gutters>
          <v-row no-gutters style="align-items: center">
            <v-col cols="12" class="d-flex pa-0 justify-space-around" style="width: 100%;">
              <div class="pa-0 align-center d-flex justify-center" v-for="tier in tiers" :key="tier.name" style="width: 48px;">
                <span style="font-size: 8px">{{ $t(`label.${tier.name.toLowerCase()}`) }}</span>
              </div>
            </v-col>
          </v-row>
        </v-row>
        <!--        <v-row no-gutters style="align-items: center" v-if="isLoggedIn">-->
        <!--          <v-col cols="12" class="d-flex pa-0 align-center justify-center pb-3" style="width: 100%;">-->
        <!--            <span style="font-size: 8px">-->
        <!--              {{ $t('label.upgradetonextlevel') }}-->
        <!--              {{ nextlevelname }}-->
        <!--              {{ $t('label.nextlevel') }}{{ progressRequired }}-->
        <!--            </span>-->
        <!--          </v-col>-->
        <!--        </v-row>-->
      </div>
      <div v-if="false" class="vip-benefits">
        <!--      <thead>-->
        <!--      <tr>-->
        <!--        <th>Game Type</th>-->
        <!--        <th>Rebate Percentage</th>-->
        <!--      </tr>-->
        <!--      </thead>-->
        <p class="titlewithbackgroundcolor">{{ $t(`label.vipbenfits`) }}</p>
        <table class="custom_table" style="width: 100%">
          <tbody>
            <tr>
              <td class="lefttext noborder">{{ $t(`label.slotrebate`) }}</td>
              <td class="righttext noborder">{{ slotpercentage }}</td>
            </tr>
            <tr>
              <td class="lefttext noborder">{{ $t(`label.casinorebate`) }}</td>
              <td class="righttext noborder">{{ casinopercentage }}</td>
            </tr>
            <tr>
              <td class="lefttext noborder">{{ $t(`label.sportrebate`) }}</td>
              <td class="righttext noborder">{{ sportpercentage }}</td>
            </tr>
            <tr>
              <td class="lefttext noborder">{{ $t(`label.depositrebate`) }}</td>
              <td class="righttext noborder">{{ depositpercentage }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="vip-benefits-mobile">
        <!--      <thead>-->
        <!--      <tr>-->
        <!--        <th>Game Type</th>-->
        <!--        <th>Rebate Percentage</th>-->
        <!--      </tr>-->
        <!--      </thead>-->
        <p class="titlewithbackgroundcolorMobile border-top titleWithBackGroundMobile justify-center d-flex align-center" style="gap: 5px">
          <img :src="`/static/svg/vipassets/vip_${levelNameMobile.toLowerCase()}.png`" width="15px" height="auto" />
          {{ $t(`label.${levelNameMobile.toLowerCase()}`) }}{{ $t(`label.benefit`) }}
        </p>
        <table class="d-flex pa-2" style="width: 100%">
          <v-row no-gutters class="d-flex justify-center align-center" style="width: 25%">
            <v-col cols="12" class="pa-0 d-flex justify-center align-center">
              <img :src="`/static/svg/vipassets/depositPercentageBonus.png`" width="60" height="auto" />
            </v-col>
            <v-col cols="12" class="pa-0 d-flex justify-center align-center">
              <label class="prize-text noborder">{{ localizedNumberText(depositPercentages, language) }}%</label>
            </v-col>
            <v-col cols="12" class="pa-0 d-flex justify-center align-center">
              <label class="description-text">{{ $t(`label.depositPercentageMobile`) }}</label>
            </v-col>
          </v-row>
          <v-row no-gutters class="d-flex justify-center align-center" style="width: 25%">
            <v-col cols="12" class="pa-0 d-flex justify-center align-center">
              <img :src="`/static/svg/vipassets/depositCoinsIcon.png`" width="60" height="auto" />
            </v-col>
            <v-col cols="12" class="pa-0 d-flex justify-center align-center">
              <label class="prize-text noborder">{{ localizedNumberText(depositCoinsPercentages, language) }}%</label>
            </v-col>
            <v-col cols="12" class="pa-0 d-flex justify-center align-center">
              <label class="description-text">{{ $t(`label.coinsMobile`) }}</label>
            </v-col>
          </v-row>
          <v-row no-gutters class="d-flex justify-center align-center" style="width: 25%">
            <v-col cols="12" class="pa-0 d-flex justify-center align-center">
              <img :src="`/static/svg/vipassets/upgradeBonusIcon.png`" width="60" height="auto" />
            </v-col>
            <v-col cols="12" class="pa-0 d-flex justify-center align-center">
              <label class="prize-text noborder">{{ upgradebonus == 0 ? '-' : '৳' + localizedNumberText(upgradebonus, language) }}</label>
            </v-col>
            <v-col cols="12" class="pa-0 d-flex justify-center align-center">
              <label class="description-text">{{ $t(`label.upgradeBonusMobile`) }}</label>
            </v-col>
          </v-row>
          <v-row no-gutters class="d-flex justify-center align-center" style="width: 25%">
            <v-col cols="12" class="pa-0 d-flex justify-center align-center">
              <img :src="`/static/svg/vipassets/birthdayBonusIcon.png`" width="60" height="auto" />
            </v-col>
            <v-col cols="12" class="pa-0 d-flex justify-center align-center">
              <label class="prize-text noborder">{{ birthdaybonus == 0 ? '-' : '৳' + localizedNumberText(birthdaybonus, language) }}</label>
            </v-col>
            <v-col cols="12" class="pa-0 d-flex justify-center align-center">
              <label class="description-text">{{ $t(`label.birthdayBonusMobile`) }}</label>
            </v-col>
          </v-row>
        </table>
      </div>
      <div class="upgrade-requirement-mobile">
        <p class="titlewithbackgroundcolorMobile border-top justify-center d-flex align-center">{{ $t(`label.upgradereq`) }}</p>
        <table class="custom_table" style="width: 100%">
          <tbody>
            <tr>
              <td class="lefttext noborder">{{ $t(`label.upgradedepreq`) }}</td>
              <td class="righttext noborder">{{ localizedNumberText(depositrequirement, language) }}</td>
            </tr>
            <tr>
              <td class="lefttext noborder">{{ $t(`label.upgradeturnreq`) }}</td>
              <td class="righttext noborder">{{ localizedNumberText(turnoverrequirement, language) }}</td>
            </tr>
            <!--            <tr>-->
            <!--              <td class="lefttext noborder">{{ $t(`label.upgradebonus`) }}</td>-->
            <!--              <td class="righttext noborder">{{ upgradebonus }}</td>-->
            <!--            </tr>-->
          </tbody>
        </table>
      </div>
      <div class="retention-requirement-mobile">
        <p class="titlewithbackgroundcolorMobile border-top justify-center d-flex align-center">{{ $t(`label.monthlyRenewal`) }}</p>
        <table class="custom_table" style="width: 100%">
          <tbody>
            <tr>
              <td class="lefttext noborder">{{ $t(`label.deposit`) }}</td>
              <td class="righttext noborder">{{ localizedNumberText(downgradecriteriaDeposit, language) }}</td>
            </tr>
            <tr>
              <td class="lefttext noborder">{{ $t(`label.reset`) }}</td>
              <td class="righttext noborder">{{ $t(`label.${downgradecriteria.toLowerCase()}`) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--      <v-col cols="12" style="padding: 0px !important; background-color: #060936;">-->
      <!--        <v-divider class="custom-divider"></v-divider>-->
      <!--      </v-col>-->
      <div class="be-bhai88-vip">
        <h1 class="headertext">{{ $t(`label.howtojointitle`) }}</h1>
        <p>1. {{ $t(`label.vip1`) }}</p>
        <p>2. {{ $t(`label.vip2`) }}</p>
        <p>3. {{ $t(`label.vip3`) }}</p>
        <p>4. {{ $t(`label.vip4`) }}</p>
        <p>5. {{ $t(`label.vip5`) }}</p>
        <p>6. {{ $t(`label.vip6`) }}</p>
        <br />
      </div>
      <v-col v-if="false" cols="12" style="padding: 0px !important; background-color: #060936;">
        <v-divider class="custom-divider"></v-divider>
      </v-col>
      <div v-if="false" class="vip-level-upgrade-info">
        <div class="vip-level-upgrade-info-inner">
          <h1 class="headertext">{{ $t(`label.viplevelupgrade`) }}</h1>
          <p style=" color:orange; text-align: left;">{{ $t(`label.howtojointitle`) }}</p>

          <p>1. {{ $t(`label.howtojoindes1`) }}</p>
          <p>2. {{ $t(`label.howtojoindes2`) }}</p>
          <p>3. {{ $t(`label.howtojoindes3`) }}</p>
          <p>4. {{ $t(`label.howtojoindes4`) }}</p>
          <!--          <p>5. {{ $t(`label.howtojoindes5`) }}</p>-->
        </div>
      </div>
      <v-col v-if="false" cols="12" style="padding: 0px !important; background-color: #060936;">
        <v-divider class="custom-divider"></v-divider>
      </v-col>
      <div class="faq-tnc-container">
        <v-btn class="faqbtn" width="100%" @click="toggleFaq">
          <span class="faqspan">{{ $t(`label.faqtitle`) }}</span>
          <div :class="['triangle', showFaq ? 'down' : 'up']"></div>
        </v-btn>
        <v-expand-transition>
          <div v-if="showFaq">
            <p class="pp">Q1. {{ $t(`label.faqviptier1`) }}</p>
            <p class="pp">{{ $t(`label.faqviptier1des`) }}</p>
            <p class="pp">Q2. {{ $t(`label.faqviptier2`) }}</p>
            <p class="pp">{{ $t(`label.faqviptier2des`) }}</p>
            <p class="pp">Q3. {{ $t(`label.faqviptier3`) }}</p>
            <p class="pp">{{ $t(`label.faqviptier3des`) }}</p>
            <p class="pp">Q4. {{ $t(`label.faqviptier4`) }}</p>
            <p class="pp">{{ $t(`label.faqviptier4des`) }}</p>
            <p class="pp">Q5. {{ $t(`label.faqviptier5`) }}</p>
            <p class="pp">{{ $t(`label.faqviptier5des`) }}</p>
            <p class="pp">Q6. {{ $t(`label.faqviptier6`) }}</p>
            <p class="pp">{{ $t(`label.faqviptier6des`) }}</p>
            <p class="pp">Q7. {{ $t(`label.faqviptier7`) }}</p>
            <p class="pp">{{ $t(`label.faqviptier7des`) }}</p>
          </div>
        </v-expand-transition>
        <!--    </div>-->
        <!--    <div class="tnc-container">-->
        <v-btn class="tncbtn" width="100%" @click="toggleTnc">
          <span class="faqspan">{{ $t(`label.tnctitle`) }}</span>
          <div :class="['triangle', showTnc ? 'down' : 'up']"></div>
        </v-btn>
        <v-expand-transition>
          <div v-if="showTnc">
            <p class="pp">1. {{ $t(`label.tncviptier1`) }}</p>
            <p class="pp">2. {{ $t(`label.tncviptier2`) }}</p>
            <p class="pp">3. {{ $t(`label.tncviptier3`) }}</p>
            <p class="pp">4. {{ $t(`label.tncviptier4`) }}</p>
            <p class="pp">5. {{ $t(`label.tncviptier5`) }}</p>
            <p class="pp">6. {{ $t(`label.tncviptier6`) }}</p>
            <p class="pp">7. {{ $t(`label.tncviptier7`) }}</p>
            <p class="pp">8. {{ $t(`label.tncviptier8`) }}</p>
          </div>
        </v-expand-transition>
      </div>
    </div>
    <div v-else>
      <div class="vip-tierdesktop-top">
        <h1 class="titledesktop">{{ $t(`label.yourVIPStatus`) }}</h1>
        <v-row no-gutters class="pt-5 justify-space-around">
          <div class="align-center justify-center d-flex " v-for="progress in levelNames" :key="progress.toLowerCase">
            <v-avatar tile class="tierpng" :style="progress === tierColorThemeName.toLowerCase() ? 'transform: scale(1.2); transition: transform 0.3s ease-in-out;' : ''">
              <v-img :src="`/static/svg/vipassets/VIP_${progress.toLowerCase()}_Wing.png`" height="auto" eager></v-img>
            </v-avatar>
          </div>
        </v-row>
        <v-container style="max-width: 1900px;">
          <v-row no-gutters class="MB-row">
            <v-col cols="12" class="MB-right-col d-flex align-center" style="height: 125px">
              <v-row style="max-width: 1240px; margin: 0 auto;">
                <v-col cols="12" class="pa-0" style="height: 120px; align-content: center">
                  <v-progress-linear style=" border-radius: 10px;" class="mt-3 customviptierprogress" height="18" color="#FF5AE4" :value="DesktopcurrentProgress" rounded>
                    <template v-slot:progress>
                      <div v-for="(progress, index) in progressLevels" :key="index" :class="['v-progress-linear__progress__segment', 'tier-' + progress.toLowerCase()]">
                        {{ progress }}
                      </div>
                    </template>
                  </v-progress-linear>
                  <br />
                </v-col>
                <v-col class="align-center pb-0 d-flex justify-center" style="max-width: 1240px; position: absolute">
                  <v-col class="align-center d-flex justify-center pa-0" v-for="tier in tiers" :key="tier.name">
                    <v-avatar class="tier-all-png-desktop">
                      <v-img :src="`/static/svg/vipassets/vip_${tier.color}.png`" class="tier-img" style="height: auto; width: 110px;"></v-img>
                    </v-avatar>
                  </v-col>
                </v-col>
              </v-row>
            </v-col>
            <v-row style="max-width: 1240px; margin: 0 auto;">
              <v-col class="align-center d-flex justify-center pt-0" style="max-width: 1240px;">
                <v-col class="align-center d-flex justify-center pa-0" v-for="tier in tiers" :key="tier.name">
                  <span style="font-size: 15px">{{ $t(`label.${tier.name.toLowerCase()}`) }}</span>
                </v-col>
              </v-col>
            </v-row>
          </v-row>
        </v-container>
        <!--        <v-row no-gutters style="align-items: center" v-if="isLoggedIn">-->
        <!--          <v-col cols="12" class="d-flex pa-0 align-center justify-center" style="width: 100%;">-->
        <!--            <span style="font-size: 16px">-->
        <!--              {{ $t('label.upgradetonextlevel') }}-->
        <!--              {{ nextlevelname }}-->
        <!--              {{ $t('label.nextlevel') }}{{ progressRequired }}-->
        <!--            </span>-->
        <!--          </v-col>-->
        <!--        </v-row>-->
      </div>
      <v-col cols="12" style="padding-left: 8% !important; padding-right: 8% !important; background-color: #1C1632;">
        <v-divider class="custom-divider"></v-divider>
      </v-col>
      <div class="vip-tierdesktop pink-border pa-0">
        <v-row no-gutters class="MB-row border-top py-3" style="height: 200px; background: transparent linear-gradient(120deg, #3D3360 0%, #0F0A20 100%);">
          <v-col cols="3" class="MB-left-col pr-4" style="display: flex; align-items: center;">
            <v-row no-gutters>
              <p style="font-size: 18px; color: white;padding-left: 20px;">{{ $t(`label.yourRewardAndBenefits`) }}</p>
            </v-row>
          </v-col>
          <v-col cols="9" class="MB-right-col d-flex align-center">
            <v-col class="align-center d-flex justify-center pa-0" v-for="tier in tiers" :key="tier.name">
              <v-avatar class="vip-all-tier-desktop">
                <v-img :src="`/static/svg/vipassets/vip_${tier.color}.png`"></v-img>
                <span class="desktop-vip-tier-text">{{ tier.color }}</span>
              </v-avatar>
            </v-col>
          </v-col>
        </v-row>
        <div class="vip-benefits">
          <p class="titlewithbackgroundcolor mb-0">{{ $t(`label.vipbenfits`) }}</p>
          <table class="custom_table" style="width: 100%">
            <tbody>
              <tr>
                <td class="lefttextdesktop noborder">{{ $t(`label.depositPercentage`) }}</td>
                <td v-for="percentage in depositPercentage" class="righttextdesktop noborder">{{ localizedNumberText(percentage, language) }}</td>
              </tr>
              <tr>
                <td class="lefttextdesktop noborder">{{ $t(`label.coins`) }}</td>
                <td v-for="percentage in depositCoinsPercentage" class="righttextdesktop noborder">{{ localizedNumberText(percentage, language) }}</td>
              </tr>
              <tr>
                <td class="lefttextdesktop noborder">{{ $t(`label.upgradeBonus`) }}</td>
                <td v-for="percentage in upgradebonuses" class="righttextdesktop noborder">{{ localizedNumberText(percentage, language) }}</td>
              </tr>
              <tr>
                <td class="lefttextdesktop noborder">{{ $t(`label.birthdayBonus`) }}</td>
                <td v-for="percentage in birthdaybonuses" class="righttextdesktop noborder">{{ localizedNumberText(percentage, language) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="upgrade-requirement">
          <p class="titlewithbackgroundcolor mb-0">{{ $t(`label.upgradereq`) }}</p>
          <table class="custom_table" style="width: 100%">
            <tbody>
              <tr>
                <td class="lefttextdesktop noborder">{{ $t(`label.upgradedepreq`) }}</td>
                <td v-for="percentage in depositrequirements" class="righttextdesktop noborder">{{ localizedNumberText(percentage, language) }}</td>
              </tr>
              <tr>
                <td class="lefttextdesktop noborder">{{ $t(`label.upgradeturnreq`) }}</td>
                <td v-for="percentage in turnoverrequirements" class="righttextdesktop noborder">{{ localizedNumberText(percentage, language) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="retention-requirement border-bottom">
          <p class="titlewithbackgroundcolor mb-0">{{ $t(`label.rententionreq`) }}</p>
          <table class="custom_table border-bottom" style="width: 100%">
            <tbody class="border-bottom">
              <tr>
                <td class="lefttextdesktop noborder">{{ $t(`label.deposit`) }}</td>
                <td v-for="percentage in downgradeturnoverrequirements" class="righttextdesktop noborder">{{ localizedNumberText(percentage, language) }}</td>
              </tr>
              <tr class="border-bottom">
                <td class="lefttextdesktop border-bottom">{{ $t(`label.reset`) }}</td>
                <td v-for="percentage in downgradecriterias" class="righttextdesktop noborder">{{ $t(`label.${percentage.toLowerCase()}`) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <v-col cols="12" v-if="false" style="padding-left: 8% !important; padding-right: 8% !important; background-color: #060936;">
        <v-divider class="custom-divider"></v-divider>
      </v-col>
      <!--      <div class="be-bhai88-vip">-->
      <!--        <h1 style="    font-size: 18px;justify-content: center;display: flex; color: #FF9E22; padding-bottom: 20px; text-align: center;">Be A BHAI88 VIP</h1>-->
      <!--        <p>Bhai88 is an online entertainment brand and a leading specialist of cricket exchange platform in Bangladesh.</p>-->
      <!--        <p>With over 100 games mixed with remarkable sromotions and 24/7 customer support services.</p>-->
      <!--        <p>There are multiple deposit payment methods for Bangladesh such as BKASH, ROCKET, NAGAD and many more to come. Be a Bhai88 VIP and enjoy generous benefits all time long!</p>-->
      <!--      </div>-->
      <!--      <v-col cols="12" style="padding: 0px !important; background-color: #0a0637;">-->
      <!--        <v-divider class="custom-divider"></v-divider>-->
      <!--      </v-col>-->
      <div class="vip-tierdesktop pt-4 pa-0 ">
        <div class="vip-level-upgrade-info border-bottom border-top">
          <div class="vip-level-upgrade-info-inner-desktop">
            <div class="infospace">
              <v-col cols="3" style="align-self: center;">
                <h1 style="font-size: 21px;color: #ffc000; ">{{ $t(`label.howtojointitle`) }}</h1>
              </v-col>
              <v-col cols="9">
                <p>1. {{ $t(`label.vip1`) }}</p>
                <p>2. {{ $t(`label.vip2`) }}</p>
                <p>3. {{ $t(`label.vip3`) }}</p>
                <p>4. {{ $t(`label.vip4`) }}</p>
                <p>5. {{ $t(`label.vip5`) }}</p>
                <p>6. {{ $t(`label.vip6`) }}</p>
              </v-col>
            </div>
          </div>
        </div>
      </div>
      <div class="vip-tierdesktop pt-4 pa-0">
        <div class="faq-tnc-container pa-0" style="display: flex; justify-content: space-between;">
          <div class="rightsidetnc">
            <v-btn class="faqbtnDesktop" width="100%" @click="toggleFaq">
              <span class="faqspan">
                <h2 style="font-size: 20px;display: flex; color: #FFC000;">{{ $t(`label.faqtitle`) }}</h2>
              </span>
              <div :class="['triangle', showFaq ? 'down' : 'up']"></div>
            </v-btn>
            <!--            <p class="pp">1. {{ $t(`label.faqviptier1`) }}</p><p class="pp">{{ $t(`label.faqviptier1des`) }}</p>-->
            <!--            <p class="pp">2. {{ $t(`label.faqviptier2`) }}</p><p class="pp">{{ $t(`label.faqviptier2des`) }}</p>-->
            <!--            <p class="pp">3. {{ $t(`label.faqviptier3`) }}</p><p class="pp">{{ $t(`label.faqviptier3des`) }}</p>-->
            <!--            <p class="pp">4. {{ $t(`label.faqviptier4`) }}</p><p class="pp">{{ $t(`label.faqviptier4des`) }}</p>-->
            <!--            <p class="pp">5. {{ $t(`label.faqviptier5`) }}</p><p class="pp">{{ $t(`label.faqviptier5des`) }}</p>-->
            <!--            <p class="pp">6. {{ $t(`label.faqviptier6`) }}</p><p class="pp">{{ $t(`label.faqviptier6des`) }}</p>-->
            <!--            <p class="pp">7. {{ $t(`label.faqviptier7`) }}</p><p class="pp">{{ $t(`label.faqviptier7des`) }}</p>-->
            <!--            <p class="pp">8. {{ $t(`label.faqviptier8`) }}</p><p class="pp">{{ $t(`label.faqviptier8des`) }}</p>-->
            <v-expand-transition>
              <div v-if="showFaq">
                <p class="pp">Q1. {{ $t(`label.faqviptier1`) }}</p>
                <p class="pp">{{ $t(`label.faqviptier1des`) }}</p>
                <p class="pp">Q2. {{ $t(`label.faqviptier2`) }}</p>
                <p class="pp">{{ $t(`label.faqviptier2des`) }}</p>
                <p class="pp">Q3. {{ $t(`label.faqviptier3`) }}</p>
                <p class="pp">{{ $t(`label.faqviptier3des`) }}</p>
                <p class="pp">Q4. {{ $t(`label.faqviptier4`) }}</p>
                <p class="pp">{{ $t(`label.faqviptier4des`) }}</p>
                <p class="pp">Q5. {{ $t(`label.faqviptier5`) }}</p>
                <p class="pp">{{ $t(`label.faqviptier5des`) }}</p>
                <p class="pp">Q6. {{ $t(`label.faqviptier6`) }}</p>
                <p class="pp">{{ $t(`label.faqviptier6des`) }}</p>
                <p class="pp">Q7. {{ $t(`label.faqviptier7`) }}</p>
                <p class="pp">{{ $t(`label.faqviptier7des`) }}</p>
              </div>
            </v-expand-transition>
          </div>
          <div class="rightsidetnc">
            <v-btn class="tncbtnDesktop" width="100%" @click="toggleFaq">
              <span class="faqspan">
                <h2 style="font-size: 20px;display: flex; color: #FFC000;">{{ $t(`label.tnctitle`) }}</h2>
              </span>
              <div :class="['triangle', showFaq ? 'down' : 'up']"></div>
            </v-btn>
            <v-expand-transition>
              <div v-if="showFaq">
                <p class="pp">1. {{ $t(`label.tncviptier1`) }}</p>
                <p class="pp">2. {{ $t(`label.tncviptier2`) }}</p>
                <p class="pp">3. {{ $t(`label.tncviptier3`) }}</p>
                <p class="pp">4. {{ $t(`label.tncviptier4`) }}</p>
                <p class="pp">5. {{ $t(`label.tncviptier5`) }}</p>
                <p class="pp">6. {{ $t(`label.tncviptier6`) }}</p>
                <p class="pp">7. {{ $t(`label.tncviptier7`) }}</p>
                <p class="pp">8. {{ $t(`label.tncviptier8`) }}</p>
              </div>
            </v-expand-transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueQrCode from 'vue-qrcode-component'
import AppLoginEmbedded from '@/components/member/loginEmbedded.vue'
import { ROUTE_NAME } from '@/constants/route.constants'
import { uiHelper, locale, errorCodeHelper, formValidator } from '@/util'
import { SHARED } from '@/constants/constants'
import { REFERRAL_GET_OVERVIEW, REFERRAL_POST_COMMISSION, REFERRAL_RESET_COMMISSION, REFERRAL_GET_CONFIG } from '@/store/referral.module'
import stringFormat from 'string-format'
import currencySymbolMapp from 'currency-symbol-map'
import { MEMBER_WALLET, MEMBER_VIP_TIER_PROGRESS } from '@/store/member.module'
import localizedNumberText from '../../filters/localized-number-text'
export default {
  name: 'viptier',
  components: {
    VueQrCode,
    AppLoginEmbedded
  },
  data: () => ({
    nextlevelname: '',
    currentIndex: 2,
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    showFaq: false,
    showTnc: false,
    dateOfBirthMenu: false,
    stringFormat: stringFormat,
    currencySymbolMapp: currencySymbolMapp,
    language: uiHelper.getLanguage(),
    currentCurrency: uiHelper.getCurrency(),
    validator: formValidator,
    shared: SHARED,
    selectedTab: 'tier',
    dates: ['', ''],
    overview: {},
    redeemCommissionAmt: 0.0,
    share_url: '',
    alertShow: false,
    alertSuccess: false,
    alertMessage: '',
    tiers: [
      { id: 1, name: 'Copper', color: 'copper', progress: 16.67 },
      { id: 2, name: 'Bronze', color: 'bronze', progress: 16.67 },
      { id: 3, name: 'Silver', color: 'silver', progress: 33.34 },
      { id: 4, name: 'Gold', color: 'gold', progress: 50.01 },
      { id: 5, name: 'Platinum', color: 'platinum', progress: 66.68 },
      { id: 6, name: 'Diamond', color: 'diamond', progress: 83.35 },
      { id: 7, name: 'Prestige', color: 'prestige', progress: 100 }
    ],
    notLoading: true,
    routeName: ROUTE_NAME,
    showProgress: false,
    tierBarBgColor: '',
    tierBarColor: '',
    tierColorThemeName: 'starter',
    progressLevels: ['Copper', 'Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond', 'Prestige'],
    currentProgress: 0,
    DesktopcurrentProgress: 0,
    tierName: '',
    currentProgressPercentage: 0,
    currentLv: 0,
    level: 1,
    slotpercentages: ['0.10', '0.50', '0.60', '0.80', '1.00'],
    casinopercentages: ['N/A', '0.10', '0.30', '0.60', '0.80'],
    sportpercentages: ['N/A', '0.20', '0.30', '0.80', '0.80'],
    depositPercentage: ['3.5', '3.5', '3.5', '3.5', '4', '5', '6'],
    depositCoinsPercentage: ['1', '1', '2', '3', '4', '5', '10'],
    depositrequirements: ['500', '30000', '100000', '250000', '500000', '1000000', '3000000'],
    turnoverrequirements: ['3000', '50000', '120000', '300000', '500000', '1000000', '3000000'],
    downgradeturnoverrequirements: ['-', '-', '50000', '125000', '250000', '500000', '1500000'],
    upgradebonuses: ['-', '350', '2000', '4000', '10000', '20000', '50000'],
    birthdaybonuses: ['-', '350', '2000', '4000', '10000', '20000', '50000'],
    downgradecriterias: ['lifetime', 'lifetime', 'monthly', 'monthly', 'monthly', 'monthly', 'monthly'],
    levelNames: ['copper', 'bronze', 'silver', 'gold', 'platinum', 'diamond', 'prestige'],
    nextLv: 0,
    progressRequired: 0
  }),
  created() {
    if (this.isLoggedIn) {
      this.getVipTierProgress()
    }

    this.metaTag()
  },
  computed: {
    levelNameMobile() {
      const percentageMap = {
        1: 'copper',
        2: 'bronze',
        3: 'silver',
        4: 'gold',
        5: 'platinum',
        6: 'diamond',
        7: 'prestige'
      }
      return percentageMap[this.level] || ''
    },
    slotpercentage() {
      const percentageMap = {
        1: '0.10%',
        2: '0.50%',
        3: '0.60%',
        4: '0.80%',
        5: '1.00%',
        6: '1.20%'
      }
      return percentageMap[this.level] || ''
    },
    casinopercentage() {
      const percentageMap = {
        1: 'N/A',
        2: '0.20%',
        3: '0.30%',
        4: '0.60%',
        5: '0.80%',
        6: '1.00%'
      }
      return percentageMap[this.level] || ''
    },
    sportpercentage() {
      const percentageMap = {
        1: 'N/A',
        2: '0.10%',
        3: '0.30%',
        4: '0.80%',
        5: '0.80%',
        6: '1.00%'
      }
      return percentageMap[this.level] || ''
    },
    depositCoinsPercentages() {
      const percentageMap = {
        1: '1',
        2: '1',
        3: '2',
        4: '3',
        5: '4',
        6: '5',
        7: '10'
      }
      return percentageMap[this.level] || ''
    },
    depositPercentages() {
      const percentageMap = {
        1: '3.5',
        2: '3.5',
        3: '3.5',
        4: '3.5',
        5: '4',
        6: '5',
        7: '6'
      }
      return percentageMap[this.level] || ''
    },
    depositrequirement() {
      const percentageMap = {
        1: '500',
        2: '30000',
        3: '100000',
        4: '250000',
        5: '500000',
        6: '1000000',
        7: '3000000'
      }
      return percentageMap[this.level] || ''
    },
    turnoverrequirement() {
      const percentageMap = {
        1: '3000',
        2: '50000',
        3: '120000',
        4: '300000',
        5: '500000',
        6: '1000000',
        7: '3000000'
      }
      return percentageMap[this.level] || ''
    },
    upgradebonus() {
      const percentageMap = {
        1: '0',
        2: '350',
        3: '2000',
        4: '4000',
        5: '10000',
        6: '20000',
        7: '50000'
      }
      return percentageMap[this.level] || ''
    },
    birthdaybonus() {
      const percentageMap = {
        1: '0',
        2: '350',
        3: '2000',
        4: '4000',
        5: '10000',
        6: '20000',
        7: '50000'
      }
      return percentageMap[this.level] || ''
    },
    downgradecriteria() {
      const percentageMap = {
        1: 'lifetime',
        2: 'lifetime',
        3: 'monthly',
        4: 'monthly',
        5: 'monthly',
        6: 'monthly',
        7: 'monthly'
      }
      return percentageMap[this.level] || ''
    },
    downgradecriteriaDeposit() {
      const percentageMap = {
        1: '-',
        2: '-',
        3: '50000',
        4: '125000',
        5: '250000',
        6: '500000',
        7: '1500000'
      }
      return percentageMap[this.level] || ''
    },
    imgSource() {
      return '/static/svg/vipassets/vip_' + this.tierColorThemeName + '.svg'
    },
    formattedValue() {
      const currencySymbol = this.currencySymbolMapp.currencySymbolMap[this.currentCurrency]
      const value = 10000
      return `${currencySymbol}${value}`
    },
    currentDate() {
      return new Date()
    },
    referralOverview() {
      return this.$store.state.referral.overview
    },

    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    totalPoint() {
      return this.overview.downline_lv1 + this.overview.downline_lv2 + this.overview.downline_lv3
    },
    redeemCommissionDetailResponseComplete() {
      return this.$store.state.referral.redeemCommissionResponse.complete
    },
    referralConfig() {
      return this.$store.state.referral.config
    },
    memberInfo() {
      return this.$store.state.member.info
    },
    webShareApiSupported() {
      return navigator.share
    },
    memberVipTierProgress() {
      return this.$store.state.member.vipTierProgress.pairing
    },
    vipTierUpgrade() {
      return this.$store.state.member.vipTierProgress.upgrade
    }
  },
  watch: {
    vipTierUpgrade() {
      if (Object.keys(this.vipTierUpgrade).length > 0) {
        if (this.vipTierUpgrade.current_upgrade_deposit > 0) {
          this.currentProgressPercentage = Math.ceil((this.vipTierUpgrade.current_upgrade_deposit / this.vipTierUpgrade.required_upgrade_deposit) * 100)
        } else {
          this.currentProgressPercentage = 0
        }

        this.progressRequired = this.vipTierUpgrade.required_upgrade_deposit - this.vipTierUpgrade.current_upgrade_deposit
        this.nextlevelname = this.vipTierUpgrade.vip_level_name
      }
      let required = Number(this.vipTierUpgrade.required_upgrade_deposit).toLocaleString()
      required = required.replace(/\.00$/, '')
      let current = Number(this.vipTierUpgrade.current_upgrade_deposit).toLocaleString()
      current = current.replace(/\.00$/, '')
      this.currentDeposit = current

      this.requiredDeposit = required
      this.progressRequired = this.vipTierUpgrade.required_upgrade_deposit - this.vipTierUpgrade.current_upgrade_deposit
      if (this.progressRequired <= 0) {
        this.progressRequired = 'Completed'
      } else {
        this.progressRequired = ' ৳ ' + Number(this.progressRequired).toLocaleString()
      }
      this.nextlevelname = this.vipTierUpgrade.vip_level_name.toLowerCase().replace(/^(.)(.*)$/, function(_, firstLetter, restOfWord) {
        return firstLetter.toUpperCase() + restOfWord.toLowerCase()
      })
      this.turnoverRequired = this.vipTierUpgrade.required_upgrade_turnover - this.vipTierUpgrade.current_upgrade_turnover
      if (this.turnoverRequired <= 0) {
        this.turnoverRequired = 'Completed'
      } else {
        this.turnoverRequired = ' ৳ ' + Number(this.turnoverRequired).toLocaleString()
      }
    },
    referralOverview() {
      this.overview = this.$store.state.referral.overview
      this.share_url = uiHelper.getHostname() + '?refer_code=' + this.overview.my_referral_code
      this.redeemCommissionAmt = this.$store.state.referral.overview.commission_balance.toFixed(2)
    },
    redeemCommissionDetailResponseComplete() {
      let response = this.$store.state.referral.redeemCommissionResponse
      if (response.complete) {
        this.redeemCommissionResponseCompleteDialog(response)
        this.$store.dispatch(`${REFERRAL_RESET_COMMISSION}`)
      }
    },
    // memberVipTierProgress() {
    //   let vipTierProgress = this.$store.state.member.vipTierProgress
    //   if (Object.keys(vipTierProgress.pairing).length > 0) {
    //     let curPairing = vipTierProgress.pairing
    //     //progress found
    //     this.showProgress = true
    //     switch (curPairing.level_sequence) {
    //       case 1:
    //         this.tierColorThemeName = 'bronze'
    //         break
    //       case 2:
    //         this.tierColorThemeName = 'silver'
    //         break
    //       case 3:
    //         this.tierColorThemeName = 'gold'
    //         break
    //       case 4:
    //         this.tierColorThemeName = 'platinum'
    //         break
    //       default:
    //         this.tierColorThemeName = 'bronze'
    //         this.tierBarBgColor = '#1867c0'
    //     }
    //     this.tierBarBgColor = 'viptier' + this.tierColorThemeName
    //     this.tierName = curPairing.name
    //     this.currentLv = this.memberVipTGierProgress.level_sequence
    //     this.nextLv = this.memberVipTierProgress.level_sequence + 1
    //   } else {
    //     //no progress
    //     this.showProgress = false
    //   }
    // },
    memberVipTierProgress() {
      let vipTierProgress = this.$store.state.member.vipTierProgress
      if (vipTierProgress && vipTierProgress.pairing) {
        if (Object.keys(vipTierProgress.pairing).length > 0) {
          let curPairing = vipTierProgress.pairing
          this.showProgress = true
          this.tierName = curPairing.name
          this.currentLv = curPairing.level_sequence
          this.nextLv = curPairing.level_sequence + 1

          // Set current progress based on the level_sequence
          switch (curPairing.level_sequence) {
            case 1: // Copper
              this.currentProgress = 15 // Set appropriate progress for Copper
              this.DesktopcurrentProgress = 15 // Adjust Desktop progress for Copper
              this.tierColorThemeName = 'copper' // Set tier color theme to Copper
              break
            case 2: // Bronze
              this.currentProgress = 29
              this.DesktopcurrentProgress = 29
              this.tierColorThemeName = 'bronze'
              break
            case 3: // Silver
              this.currentProgress = 43
              this.DesktopcurrentProgress = 43
              this.tierColorThemeName = 'silver'
              break
            case 4: // Gold
              this.currentProgress = 57
              this.DesktopcurrentProgress = 57
              this.tierColorThemeName = 'gold'
              break
            case 5: // Platinum
              this.currentProgress = 71
              this.DesktopcurrentProgress = 71
              this.tierColorThemeName = 'platinum'
              break
            case 6: // Diamond
              this.currentProgress = 86
              this.DesktopcurrentProgress = 85
              this.tierColorThemeName = 'diamond'
              break
            case 7: // Prestige
              this.currentProgress = 100
              this.DesktopcurrentProgress = 100
              this.tierColorThemeName = 'prestige'
              break
            default:
              this.currentProgress = 0
              this.DesktopcurrentProgress = 0
              this.tierColorThemeName = 'starter'
          }
        } else {
          this.showProgress = false
        }
      }
    },

    isLoggedIn() {
      if (this.isLoggedIn) {
        this.getVipTierProgress()
      }
    }
  },
  methods: {
    localizedNumberText,
    selectVipTierLevel(tierId) {
      this.level = tierId
    },
    metaTag() {
      const currentUrl = window.location.href
      uiHelper.setCanonical(currentUrl)
      if (this.$route.params.lang) {
        uiHelper.setTitle(`${locale.getMessage('meta.vipTier_lang_title')}`)
        uiHelper.setMetaTag('description', `${locale.getMessage('meta.vipTier_lang_description')}`)
      } else {
        uiHelper.setTitle(`${locale.getMessage('meta.vipTier_title')}`)
        uiHelper.setMetaTag('description', `${locale.getMessage('meta.vipTier_description')}`)
      }
      const domainWithProtocol = currentUrl.split('/')[2]
      const domain = domainWithProtocol.replace(/(^\w+:|^)\/\//, '')
      // const Links = `https://${domain}${window.location.pathname}`;
      // const Linksen = `https://${domain}/en-BD${window.location.pathname}`;
      // const Linksbn = `https://${domain}/bn-BD${window.location.pathname}`;
      const path = window.location.pathname
      const cleanPath = path.replace(/\/(en-BD|bn-BD)/i, '')
      const Links = `https://${domain}${cleanPath}`
      const Linksen = `https://${domain}/en-BD${cleanPath}`
      const Linksbn = `https://${domain}/bn-BD${cleanPath}`
      uiHelper.setHreflangLinks(Links)
      uiHelper.setHreflangLinksen(Linksen)
      uiHelper.setHreflangLinksbd(Linksbn)
    },
    textColorUppercase() {
      return this.getTextColor().toUpperCase()
    },
    handleTouchStart(event) {
      this.touchStartX = event.touches[0].clientX // Get initial touch position
    },
    handleTouchEnd(event) {
      this.touchEndX = event.changedTouches[0].clientX // Get final touch position

      if (this.touchEndX < this.touchStartX - 50) {
        // Swipe Left (Next Wheel)
        this.showNextLevel()
      } else if (this.touchEndX > this.touchStartX + 50) {
        // Swipe Right (Previous Wheel)
        this.showPreviousLevel()
      }
    },
    showPreviousLevel() {
      if (this.level > 1) {
        this.level--
      }
      // else {
      //   this.level = this.levelNames.length
      // }
    },
    showNextLevel() {
      if (this.level < this.levelNames.length) {
        this.level++
      }
      // else {
      //   this.level = 1
      // }
    },
    getTextColor() {
      return this.levelNames[this.level - 1] || ''
    },
    previousTextColor() {
      const prevIndex = (this.level - 2 + this.levelNames.length) % this.levelNames.length
      return this.levelNames[prevIndex]
    },
    nextTextColor() {
      const nextIndex = this.level % this.levelNames.length
      return this.levelNames[nextIndex]
    },
    getVipTierProgress() {
      this.$store.dispatch(MEMBER_VIP_TIER_PROGRESS)
    },
    toggleFaq() {
      this.showFaq = !this.showFaq
    },
    toggleTnc() {
      this.showTnc = !this.showTnc
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        console.log('Text copied to clipboard')
      })
    },
    // copyToClipboard(referralCode) {
    //   const textField = document.createElement('textarea')
    //   textField.innerText = referralCode
    //   document.body.appendChild(textField)
    //   textField.select()
    //   document.execCommand('copy')
    //   textField.remove()
    //   this.isCopied = true
    //   setTimeout(() => { this.isCopied = false }, 3000)
    // },
    getReferralConfig() {
      this.$store.dispatch(`${REFERRAL_GET_CONFIG}`)
    },
    getConfig(index) {
      let config = this.referralConfig.find(c => c.level == index)
      if (config) {
        return config.percentage
      } else {
        return 0
      }
    },
    openMsgDialog(selectedMsg) {
      this.msgDialog = {
        show: true,
        msg: selectedMsg.message,
        title: selectedMsg.subject
      }
    },
    closeMsgDialog() {
      this.msgDialog = {
        show: false
      }
    },
    getReferralOverview() {
      if (this.isLoggedIn) this.$store.dispatch(`${REFERRAL_GET_OVERVIEW}`)
    },
    redeemCommissionConfirmationDialog() {
      let self = this
      if (this.$refs.redeemForm.validate()) {
        let dialog = this.initializePageDialogProperty()
        dialog.title = locale.getMessage(`label.redeemConfirmation`)
        dialog.message.push(this.stringFormat(locale.getMessage(`message.ConfirmCommission`), self.$options.filters.currency(this.redeemCommissionAmt, this.currentCurrency)))
        dialog.button.push({
          title: locale.getMessage(`label.confirm`),
          action: () => this.redeemCommission()
        })
        this.openPageDialog(dialog)
      }
    },
    redeemCommission() {
      let obj = { amount: this.redeemCommissionAmt }
      this.$store.dispatch(`${REFERRAL_POST_COMMISSION}`, {
        obj
      })
    },
    redeemCommissionResponseCompleteDialog(response) {
      this.closePageDialog()
      if (response.code != 0 && !response.success) {
        this.$parent.$parent.openAlert(false, errorCodeHelper.getErrorCodeDesc(response.code))
      } else {
        this.$parent.$parent.openAlert(true, locale.getMessage(`message.commissionRedeemSuccess`))
      }
    },
    initializePageDialogProperty() {
      let initPageDialog = {
        title: locale.getMessage(`label.system`),
        dialogXButton: this.closePageDialog,
        messageTitle: '',
        message: [],
        button: []
      }
      return initPageDialog
    },
    openPageDialog(dialog) {
      this.$eventHub.$emit('open-page-dialog', dialog)
    },
    closePageDialog() {
      this.$eventHub.$emit('close-page-dialog', true)
    },
    share() {
      const sharing = {
        title: locale.getMessage(`message.referralShareTitle`),
        text: locale.getMessage(`message.referralShareMsg`),
        url: this.share_url
      }
      if (this.webShareApiSupported) {
        navigator.share(sharing)
      } else {
        let $f = this
        this.$copyText(this.share_url).then(function(e) {
          $f.alertMessage = 'Referral Link Copied!'
          $f.alertSuccess = true
          $f.alertShow = true
        })
      }
    }
  }
}
</script>

<style lang="scss">
.vipTier-description-text {
  background: linear-gradient(to right, #6a0080, #3b0055, #1a002b);
  padding: 12px 20px;
  color: #ffcc00; /* Text color */
  font-weight: bold;
  font-size: 18px;
  border-radius: 5px;
  mask-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, black 8%, black 80%, rgba(0, 0, 0, 0) 100%);
}
.header-font-size {
  font-size: 18px;
}
.vip-tier-header-font-size-bigger {
  font-size: 26px;
}
.yellow-theme-color {
  color: #ffc000;
}
.theme-color {
  color: #322c44 !important;
}
.v-progress-linear__buffer {
  background: #770073 !important;
}
.border-bottom {
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

.pink-border {
  border: 2px solid #c817c2;
  border-radius: 6px;
}
.desktop-vip-tier-text {
  font-size: 16px;
}
.prize-text {
  color: #ffc000;
  font-size: 14px;
}
.description-text {
  font-size: 10px;
}
.rank-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  position: relative;
  width: 100%;
}
.half-container {
  overflow: hidden; /* Hide the other half */
  position: relative;
}

.left-half {
  position: absolute;
  right: 0;
}

.right-half {
  position: absolute;
  left: 0;
}

.half-image {
  position: relative;
}

.left-image {
  transform: translateX(-50%); /* Shift image left to show only left half */
}

.right-image {
  transform: translateX(50%); /* Shift image right to show only right half */
}

.faded-rank {
  opacity: 0.4; /* Makes side images faded */
  transition: all 0.3s ease-in-out;
}
.Height-Vip {
  height: 320px;
}
.custom_table {
  background-color: #322c44;
  th,
  td {
    padding: 8px;
  }
}
.infospace {
  display: flex;
  width: 100%;
}
.vip-all-tier-desktop {
  height: auto !important;
  min-width: 48px !important;
  border-radius: 0px;
  overflow: inherit;
  margin: auto;
  display: flex;
  flex-direction: column;

  span {
    padding-top: 10px;
    text-transform: capitalize;
  }
}
.vipcard_asset {
  height: 250px;
  width: 250px;
}
.tierpng {
  height: auto !important;
  min-width: 48px !important;
  width: 150px !important;
  border-radius: 0px !important;
}
.tierSidePng {
  height: auto !important;
  min-width: 48px !important;
  width: 100px !important;
  border-radius: 0 !important;
}
.btnleft {
  background-color: transparent !important;
  z-index: 1;
}

.btnright {
  background-color: transparent !important;
  z-index: 1;
}
.title3 {
  font-size: 18px;
  color: white;
}
.leftside {
  justify-content: center;
  align-items: center;
  display: flex;
}
.leftsidefaq {
  border-radius: 10px;
  width: 49%;
  padding: 20px;
  p {
    font-size: 16px;
  }
}
.rightsidetnc {
  border-radius: 10px;
  width: 49%;
  background: #322c44;
  padding: 20px;
  p {
    font-size: 16px;
  }
}

.lines {
  color: blue;
  font-size: 24px;
  margin-bottom: 10px;
}
.linesmobile {
  justify-content: center;
  display: flex;
  color: blue;
  font-size: 14px;
  margin-bottom: 10px !important;
}
.v-progress-linear__determinate {
  border-radius: 13px;
  height: 17px;
}
.rightside {
  display: flex;
  flex-direction: column;
  width: 70%;
  margin-left: 10%;
}

.v-progress-linear__background {
  background-color: #770073 !important;
  opacity: 1 !important;
}

.viptitle {
  color: white;
  font-size: 18px;
}
.titledesktop {
  color: white;
  text-align: left;
  font-size: 18px;
  padding-left: 20px;
}
.title2 {
  color: white;
  font-size: 18px;
  margin-top: 25px;
}

.titlewithbackgroundcolor {
  font-size: 18px;
  color: white;
  padding-left: 20px;
  background-color: #413275;
  padding-top: 10px;
  padding-bottom: 10px;
  //margin-left: -20px;
  //margin-right: -20px;
}
.titlewithbackgroundcolorMobile {
  font-size: 18px;
  color: white;
  background-color: #413275;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 0px !important;
  //margin-left: -20px;
  //margin-right: -20px;
}
.border-top {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.titleWithBackGroundMobile {
  background-color: #c817c2;
}
.noborder {
  border-bottom: 0px;
}

.v-expand-transition p {
  font-size: 12px;
}
.faqbtn,
.tncbtn {
  background: #1c1632 !important;
  color: white !important;
  border: 2px solid #c817c2;
  justify-content: start;
  margin-bottom: 10px;
}
.faqbtnDesktop,
.tncbtnDesktop {
  background: transparent !important;
  color: white !important;
  justify-content: start;
}
.triangle {
  width: 0;
  height: 0;
  right: 0;
  position: absolute;
  border-style: solid;
  border-width: 0 5px 5px 5px;
  border-color: transparent transparent #ffffff transparent;
}

.triangle.up {
  transform: translate(-50%, -50%) rotate(180deg);
  top: 60%;
}

.triangle.down {
  transform: translate(-50%, -50%);
  top: 40%;
}
.faq-tnc-container {
  padding: 10px;
  color: white;
}
.vip-tier {
  background: transparent linear-gradient(180deg, #c817c23f 0%, #c817c2ad 16%, #13101c 100%);
  color: white;
}
.vip-tierdesktop-top {
  padding-left: 10% !important;
  padding-right: 10% !important;
  background: transparent linear-gradient(283deg, #800e7d 0%, #000000 100%) 0 0 no-repeat padding-box;
  padding: 20px;
  color: white;
}
.vip-tierdesktop {
  margin-left: 10% !important;
  margin-right: 10% !important;
  background-color: #1c1632;
  padding: 20px;
  color: white;
}
.vip-level-upgrade-info {
  background-color: #322c44;
  display: flex;
  justify-content: center;
  padding: 20px;
  color: white;
}
.vip-level-upgrade-info-inner {
  height: 590px;
  width: 100%;
  padding: 15px;
  border-radius: 5px;
}
.vip-level-upgrade-info-inner-desktop {
  width: 100%;
  padding: 15px;
  border-radius: 5px;
}
.be-bhai88-vip {
  background-color: #322c44;
  color: white;
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
  padding-top: 20px;
  border-radius: 6px;
  margin: 10px;
  p {
    font-size: 12px;
  }
}
.vip-benefits {
  background: transparent linear-gradient(120deg, #3d3360 0%, #0f0a20 100%) 0% 0% no-repeat padding-box;
  color: white;
}
.vip-benefits-mobile {
  background: #413275;
  color: white;
  border: 2px solid #c817c2;
  border-radius: 5px;
  margin: 10px;
}
.upgrade-requirement {
  background: transparent linear-gradient(120deg, #3d3360 0%, #0f0a20 100%) 0% 0% no-repeat padding-box;
  color: white;
}
.upgrade-requirement-mobile {
  background: #413275;
  color: white;
  border: 2px solid #c817c2;
  border-radius: 5px;
  margin: 10px;
}
.retention-requirement-mobile {
  background: #413275;
  color: white;
  border: 2px solid #c817c2;
  border-radius: 5px;
  margin: 10px;
}
.retention-requirement {
  background: transparent linear-gradient(120deg, #3d3360 0%, #0f0a20 100%) 0% 0% no-repeat padding-box;
  color: white;
}
.pp {
  font-size: 12px;
}

.lefttext {
  text-align: left;
  color: white;
  font-size: 12px;
}
.lefttextdesktop {
  text-align: left;
  color: white;
  font-size: 12px;
  width: 25%;
}
.righttext {
  text-align: right;
  color: white;
  font-size: 12px;
}
.righttextdesktop {
  text-align: center;
  color: white;
  font-size: 12px;
  width: 110px;
}
.vip-level-upgrade-info p,
.be-bhai88-vip p {
  font-size: 16px;
}
.blue-text {
  color: #0047ff;
}
.progress-details-col {
  font-size: 15px;
}
.tier-all-png {
  height: auto !important;
  //min-width: 60% !important;
  //width: 60% !important;
}
.tier-all-png-desktop {
  border-radius: 0px;
  overflow: inherit;
  width: 56px !important;
  height: auto !important;
  margin: 15px 2.7% 0px;
  display: flex;
  flex-direction: column;

  span {
    font-size: 18px;
    text-transform: capitalize;
    margin-top: 8px;
  }
}
.faqspan {
  font-size: 15px;
}
.headertext {
  font-size: 18px;
  color: rgb(255, 158, 34);
  text-align: center;
  padding-bottom: 20px;
}
//@media (max-width: 1600px) {
//  .vipcard_asset{
//    height: 200px;
//    width: 200px;
//  }
//  .tier-all-png-desktop {
//    width: 135px !important;
//    height: 80px !important;
//    margin: 3px 2px 0px;
//  }
//}
//@media (max-width: 1500px){
//  .tier-all-png-desktop {
//    width: 115px !important;
//    height: 74px !important;
//    margin: 3px 4px 0px;
//  }
//}
//
//
//@media (max-width: 1500px) {
//  .tier-all-png-desktop {
//    width: 102px !important;
//    height: 60px !important;
//    margin: 3px 13px 0px;
//  }
//}
//@media (max-width: 1400px) {
//  .tier-all-png-desktop {
//    width: 96px !important;
//    height: 55px !important;
//    margin: 3px 9px 0px;
//  }
//}
//
//@media (max-width: 1280px){
//  .tier-all-png-desktop {
//    width: 106px !important;
//    height: 60px !important;
//    margin: 3px 3px 0px;
//  }
//}
@media screen and (max-width: 1280px) {
  .tier-all-png-desktop {
    width: 83px !important;
    height: 50px !important;
    margin: 3px 10px 0px;
  }
  .tier-img {
    height: auto !important;
    max-width: 80px !important;
  }
}

@media (max-width: 1190px) {
  .tier-all-png-desktop {
    width: 72px !important;
    //height: 43px !important;
    margin: 3px 11px 0px;
  }
  .Height-Vip {
    height: 270px;
  }
}

@media (max-width: 1095px) {
  .desktop-vip-tier-text {
    font-size: 12px;
  }
  .title2 {
    margin-bottom: 0px !important;
  }
  .vipcard_asset {
    height: 200px;
    width: 200px;
  }
  .tier-all-png-desktop {
    //width: 83px !important;
    //height: 51px !important;
    margin: 3px 3px 0px;
  }
  .tier-img {
    max-width: 77px !important;
  }
  .infospace {
    width: 100%;
  }
}
@media (max-width: 975px) {
  .vipcard_asset {
    height: 200px;
    width: 200px;
  }
  .tier-all-png-desktop {
    //width: 75px !important;
    //height: 43px !important;
    margin: 3px 3px 0px;
  }
  .infospace {
    width: 100%;
  }
}
@media (max-width: 950px) {
  .vipcard_asset {
    height: 200px;
    width: 200px;
  }
  .tier-all-png-desktop {
    width: 70px !important;
    //height: 43px !important;
    margin: 3px 3px 0px;
  }
}
@media (max-width: 900px) {
  .infospace {
    width: 100%;
  }
  .vip-level-upgrade-info-inner-desktop {
    width: 100%;
  }
  .vipcard_asset {
    height: 200px;
    width: 200px;
  }
  .tier-all-png-desktop {
    width: 60px !important;
    //height: 35px !important;
    margin: 3px 2px 0px;
  }
  .tier-img {
    max-width: 65px !important;
  }
}
@media (max-width: 800px) {
  .Height-Vip {
    height: 220px;
  }
  .vipcard_asset {
    height: 200px;
    width: 200px;
  }
  .infospace {
    width: 100%;
  }
  .tier-all-png-desktop {
    width: 50px !important;
    //height: 29px !important;
    margin: 3px 2px 0px;
  }
  .tier-img {
    max-width: 55px !important;
  }
}

@media (max-width: 540px) {
  .be-bhai88-vip {
    p {
      font-size: 12px !important;
    }
  }
  .custom_table {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    background-color: #322c44;
  }
  .title3 {
    font-size: 16px;
  }
  .title2 {
    font-size: 16px;
  }
  .titlewithbackgroundcolor {
    font-size: 16px;
  }
  .titlewithbackgroundcolorMobile {
    font-size: 16px;
  }
  .h1 {
    font-size: 16px;
  }
}
@media (max-width: 490px) {
  .title3,
  .faqspan {
    font-size: 14px;
  }
  .title2 {
    font-size: 14px;
  }
  .titlewithbackgroundcolor {
    font-size: 14px;
  }
  .titlewithbackgroundcolorMobile {
    font-size: 14px;
  }
  .headertext {
    font-size: 14px;
  }
  .lefttext,
  .righttext,
  .vip-level-upgrade-info p,
  .be-bhai88-vip p,
  .pp {
    font-size: 12px;
  }
  .btnleft {
    height: 30px !important;
    min-width: 50px !important;
  }
  .btnright {
    height: 30px !important;
    min-width: 50px !important;
  }
}

@media (max-width: 440px) {
  //.tierpng {
  //  height: 140px !important;
  //  min-width: 48px !important;
  //  width: 160px !important;
  //}
  //.lefttext, .righttext ,.vip-level-upgrade-info p,
  //.be-bhai88-vip p, .pp {
  //  font-size: 9px;
  //}
  .title3,
  .faqspan {
    font-size: 12px;
  }
  .vip-level-upgrade-info-inner {
    height: 715px;
  }
  .titlewithbackgroundcolor {
    font-size: 12px;
  }
  .titlewithbackgroundcolorMobile {
    font-size: 12px;
  }
  .headertext {
    font-size: 12px;
  }
  .title2 {
    font-size: 12px;
  }

  .btnleft {
    height: 25px !important;
    min-width: 45px !important;
  }
  .btnright {
    height: 25px !important;
    min-width: 45px !important;
  }
}

@media (max-width: 375px) {
  //.lefttext, .righttext ,.vip-level-upgrade-info p,
  //.be-bhai88-vip p, .pp {
  //  font-size: 7.7px;
  //}
  .title3,
  .faqspan {
    font-size: 9.7px;
  }
  .title2 {
    font-size: 9.7px;
  }
  .headertext {
    font-size: 9.7px;
  }
  //.tierpng {
  //  height: 115px !important;
  //  min-width: 48px !important;
  //  width: 135px !important;
  //}
  .btnleft {
    height: 20px !important;
    min-width: 40px !important;
  }
  .btnright {
    height: 20px !important;
    min-width: 40px !important;
  }
  .progress-details-col {
    font-size: 15px;
  }
}
@media (max-width: 280px) {
  .btnleft {
    height: 15px !important;
    width: 20px !important;
  }
  .btnright {
    height: 15px !important;
    width: 20px !important;
  }
  //.tierpng {
  //  height: 83px !important;
  //  min-width: 48px !important;
  //  width: 98px !important;
  //}
  .vip-level-upgrade-info-inner {
    height: 834px;
  }
}
</style>
